document.querySelectorAll('.gform_wrapper.gravity-theme select').forEach(select => {
    select.addEventListener('change', function() {
        if (this.value === '') {
            this.style.color = '#8B79A4';
        } else {
            this.style.color = '#fff';
        }
    });
    
    if (select.value === '') {
        select.style.color = '#8B79A4';
    }
});